import styled from 'styled-components'

export const Home = styled.div`
  [role='dialog'] {
    z-index: 1;
    position: fixed;
  }
`

export const Content = styled.div`
  width: 100%;
  margin: 0 auto;
  padding: 0;
`
